import { ChartOfAccountsTemplateStartingPoint } from "@common/constants/domains/accounting/chartOfAccountsTemplateStartingPoint";

export interface ChartOfAccountsTemplateStartingPointSelection {
    startingPoint: ChartOfAccountsTemplateStartingPoint;
    sourceTemplateId: string | null;
    sourceEntityId: number | null;
}

export const defaultStartingPointSelection: ChartOfAccountsTemplateStartingPointSelection =
    {
        startingPoint: ChartOfAccountsTemplateStartingPoint.default,
        sourceTemplateId: null,
        sourceEntityId: null,
    };

interface StartingPointPayload {
    startingPoint: ChartOfAccountsTemplateStartingPoint;
    sourceTemplateId?: string;
    sourceEntityId?: number;
}

// Maps the picker selection to the create-schema source fields, only ever
// emitting the source id that matches the chosen starting point so the schema
// refinements (copyTemplate ⇒ sourceTemplateId, copyEntity ⇒ sourceEntityId)
// are satisfied and no mismatched source id is sent.
export function buildStartingPointPayload(
    selection: ChartOfAccountsTemplateStartingPointSelection,
): StartingPointPayload | null {
    switch (selection.startingPoint) {
        case ChartOfAccountsTemplateStartingPoint.copyTemplate:
            return {
                startingPoint: selection.startingPoint,
                sourceTemplateId: selection.sourceTemplateId ?? undefined,
            };
        case ChartOfAccountsTemplateStartingPoint.copyEntity:
            return {
                startingPoint: selection.startingPoint,
                sourceEntityId: selection.sourceEntityId ?? undefined,
            };
        case ChartOfAccountsTemplateStartingPoint.default:
            return { startingPoint: selection.startingPoint };
        case ChartOfAccountsTemplateStartingPoint.importCoa:
            return null;
    }
}

// True when the selection has every source id its starting point requires, so
// the create request will pass schema validation rather than 400.
export function isStartingPointSelectionComplete(
    selection: ChartOfAccountsTemplateStartingPointSelection,
): boolean {
    switch (selection.startingPoint) {
        case ChartOfAccountsTemplateStartingPoint.copyTemplate:
            return selection.sourceTemplateId !== null;
        case ChartOfAccountsTemplateStartingPoint.copyEntity:
            return selection.sourceEntityId !== null;
        case ChartOfAccountsTemplateStartingPoint.default:
            return true;
        case ChartOfAccountsTemplateStartingPoint.importCoa:
            return false;
    }
}
